module.exports = __webpack_public_path__ + "static/media/store9.d32a2388.jpg";